import { render, staticRenderFns } from "./checkboxGroup.vue?vue&type=template&id=6d8f9316&scoped=true&"
import script from "./checkboxGroup.vue?vue&type=script&lang=js&"
export * from "./checkboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./checkboxGroup.vue?vue&type=style&index=0&id=6d8f9316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8f9316",
  null
  
)

export default component.exports